import { Facebook, Instagram, Youtube } from 'lucide-react';
import { SOCIALS } from '../../lib/site';

const TikTokIcon = ({ className = '' }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.36a8.16 8.16 0 0 0 4.77 1.52V6.4a4.85 4.85 0 0 1-1.84-.31z" />
  </svg>
);

const ITEMS = [
  { key: 'fb', label: 'Facebook', href: SOCIALS.facebook, Icon: Facebook },
  { key: 'ig', label: 'Instagram', href: SOCIALS.instagram, Icon: Instagram },
  { key: 'tiktok', label: 'TikTok', href: SOCIALS.tiktok, Icon: TikTokIcon },
  { key: 'youtube', label: 'YouTube', href: SOCIALS.youtube, Icon: Youtube },
];

export const SocialLinks = ({ prefix }) => (
  <div className="flex gap-3 flex-wrap">
    {ITEMS.map(({ key, label, href, Icon }) => (
      <a
        key={key}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        data-testid={`${prefix}-social-${key}`}
        className="w-11 h-11 rounded-full border border-white/15 bg-white/5 text-slate-200 flex items-center justify-center hover:bg-orange-500 hover:border-orange-500 hover:text-white hover:-translate-y-0.5"
      >
        <Icon className="w-5 h-5" />
      </a>
    ))}
  </div>
);
